import { PanelsLeftBottom, Upload } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/ui/empty-state';
import { FLOOR_PLAN_CAPTION } from './floorPlan';

type FloorPlanEmptyStateProps = {
  /**
   * Opens the Floor Plan upload, when this user can upload here. The page
   * shows a customer the tab only once there is a floor plan, so today only
   * internal users (who can upload) reach this; the copy still keys off the
   * action itself, so it can never promise an upload the tab does not offer.
   */
  onUpload?: () => void;
  className?: string;
};

/** The Floor Plan tab with no floor plans (DV-3735). */
const FloorPlanEmptyState = ({
  onUpload,
  className
}: FloorPlanEmptyStateProps) => (
  <EmptyState
    className={className}
    icon={PanelsLeftBottom}
    title="No Floor Plans Yet"
    description={
      onUpload
        ? `Uploaded images are captioned “${FLOOR_PLAN_CAPTION}” and added to the end of the Photos tab.`
        : 'Floor plans for this photoset will appear here.'
    }
    action={
      onUpload && (
        <Button type="button" onClick={onUpload}>
          <Upload className="h-4 w-4" />
          Upload Floor Plans
        </Button>
      )
    }
  />
);

export default FloorPlanEmptyState;
